export default function colorStyleMap(style) {
  style.map(function(color) {
    const type = color.substr(0, color.indexOf('_'));
    const value = color.substring(color.indexOf('_') + 1);
    style[type] = value;
  });

  return style;
}
